export const servicesContent = {
  en: {
    intro: "",
    readMore: "Read More",
    readLess: "Read Less",
    bookConsultation: "Book Now",
    contactMe: "Contact Me",
    headings: {
      what: "What is this service?",
      who: "Who is it for?",
      expect: "What can you expect?",
      book: "Book a consultation"
    },
    bookingText: "",
    services: [
      {
        key: "weight-management",
        icon: "scale",
        iconColor: "text-emerald-600",
        iconBackground: "bg-emerald-100",
        title: "Weight Management",
        summary: "Personalised nutrition support to help you lose weight, build healthier habits, and maintain your progress long term without restrictive dieting.",
        what: "A supportive, realistic approach to sustainable fat loss and weight management. We focus on balanced nutrition and habits you can maintain, rather than fad diets or quick fixes.",
        who: "For anyone who wants to manage their weight, improve eating habits, feel more in control around food, or move away from repeated cycles of restrictive dieting.",
        expect: "Together, we can work on balanced meals, portion awareness, cravings, emotional or habitual eating, meal planning and practical routines that fit your lifestyle."
      },
      {
        key: "glp1-support",
        icon: "syringe",
        iconColor: "text-sky-600",
        iconBackground: "bg-sky-100",
        title: "GLP-1 Nutrition Support",
        summary: "Nutrition support while taking Ozempic, Mounjaro or Wegovy, or any other GLP-1, with guidance around protein, appetite changes, side effects and long-term habits.",
        what: "Nutrition support while taking Ozempic, Mounjaro or Wegovy, or any other GLP-1, as a complement to the prescription of these medications.",
        who: "For people who are at the start of their journey on weight-loss medication, currently taking it, or in their maintenance phase and want support with food and long-term habits.",
        expect: "Practical guidance around protein, appetite changes, side effects, hydration, fibre, muscle maintenance and creating long-term habits."
      },
      {
        key: "gut-health",
        icon: "gut",
        iconColor: "text-orange-500",
        iconBackground: "bg-orange-100",
        title: "Gut Health & IBS",
        summary: "Evidence-based nutrition support for IBS, bloating, reflux, constipation, diarrhoea, and digestive discomfort.",
        what: "A personalised review of your diet, digestive symptoms and daily routine to identify practical ways to support your gut health and comfort.",
        who: "For people experiencing IBS, bloating, reflux, constipation, diarrhoea, digestive discomfort or uncertainty about which foods may be triggering symptoms.",
        expect: "Support with symptom and food tracking, IBS-friendly eating, fibre, fluids, meal timing and carefully considered dietary changes to help rebuild confidence around food."
      },
      {
        key: "womens-health",
        icon: "venus",
        iconColor: "text-purple-600",
        iconBackground: "bg-purple-100",
        title: "Women's Health",
        summary: "Nutrition support and guidance for PMOS, endometriosis, fertility, pregnancy, gestational diabetes, perimenopause and menopause.",
        what: "Personalised nutrition guidance for women at any life stage with a practical focus on food, habits and wellbeing.",
        who: "For people looking for support with PMOS, endometriosis, fertility, pregnancy, perimenopause or menopause.",
        expect: "An individual plan built around your symptoms, health priorities and lifestyle, with balanced meals and sustainable routines rather than restrictive rules."
      },
      {
        key: "diabetes",
        icon: "droplet",
        iconColor: "text-red-500",
        iconBackground: "bg-red-100",
        title: "Prediabetes & Type 2 Diabetes",
        summary: "Practical nutrition guidance to support blood sugar control, reduce insulin resistance, and manage prediabetes and Type 2 diabetes.",
        what: "Clear, everyday nutrition support to help you understand how food choices and routines can support blood glucose management.",
        who: "For people with insulin resistance, prediabetes or Type 2 diabetes who want practical guidance that works alongside their medical care.",
        expect: "We can explore balanced meals, carbohydrate awareness, regular eating patterns, movement and realistic lifestyle changes without labelling foods as simply good or bad."
      },
      {
        key: "blood-tests",
        icon: "clipboard",
        iconColor: "text-rose-600",
        iconBackground: "bg-rose-100",
        title: "Cholesterol & Heart Health",
        summary: "Understand your blood results and how nutrition can make an impact while putting an action plan in place.",
        what: "A nutrition-focused review of recent blood test results to help make the numbers easier to understand and turn relevant findings into realistic food and lifestyle actions. This is not a medical diagnosis service.",
        who: "For clients with blood results that show high total cholesterol, LDL or triglycerides, low HDL, or who have been diagnosed with high blood pressure.",
        expect: "We will discuss nutrition-related markers in context, review your current eating habits and create a practical plan. You should continue to follow all medical advice and discuss diagnosis or treatment with your healthcare team."
      }
    ]
  },
  es: {
    intro: "",
    readMore: "Leer más",
    readLess: "Leer menos",
    bookConsultation: "Reservar",
    contactMe: "Contactar",
    headings: {
      what: "¿En qué consiste este servicio?",
      who: "¿Para quién es?",
      expect: "¿Qué puedes esperar?",
      book: "Reserva una consulta"
    },
    bookingText: "",
    services: [
      {
        key: "weight-management",
        icon: "scale",
        iconColor: "text-emerald-600",
        iconBackground: "bg-emerald-100",
        title: "Pérdida y control de peso",
        summary: "Apoyo nutricional personalizado para perder peso, crear hábitos saludables y mantener los cambios a largo plazo sin dietas restrictivas.",
        what: "Un enfoque cercano y realista para la pérdida de grasa sostenible y el control de peso, basado en una alimentación equilibrada y hábitos duraderos, sin dietas de moda ni soluciones rápidas.",
        who: "Para quienes desean controlar su peso, mejorar sus hábitos, sentirse con más control ante la comida o dejar atrás los ciclos de dietas restrictivas.",
        expect: "Trabajaremos en comidas equilibradas, porciones, antojos, alimentación emocional o por hábito, planificación y rutinas prácticas adaptadas a tu vida."
      },
      {
        key: "glp1-support",
        icon: "syringe",
        iconColor: "text-sky-600",
        iconBackground: "bg-sky-100",
        title: "Acompañamiento nutricional durante el tratamiento con GLP-1",
        summary: "Apoyo durante el tratamiento, con orientación sobre proteínas, cambios de apetito, efectos secundarios, masa muscular y hábitos a largo plazo.",
        what: "Apoyo nutricional para personas que toman medicamentos GLP-1 como Ozempic, Wegovy o Mounjaro, como complemento a la prescripción de estos medicamentos.",
        who: "Para personas que van a empezar, ya toman o se preparan para dejar esta medicación y quieren trabajar en la alimentación y la creación de hábitos duraderos.",
        expect: "Orientación práctica sobre proteínas, fibra, hidratación, porciones y horario de las comidas, mantenimiento muscular, efectos secundarios de GLP-1 y creación de hábitos a largo plazo."
      },
      {
        key: "gut-health",
        icon: "gut",
        iconColor: "text-orange-500",
        iconBackground: "bg-orange-100",
        title: "Salud intestinal",
        summary: "Apoyo nutricional basado en la evidencia para síndrome del intestino irritable (SII), SIBO, reflujo, estreñimiento, diarrea y molestias digestivas.",
        what: "Una revisión personalizada de tu alimentación, síntomas digestivos y rutina para encontrar formas prácticas de cuidar tu salud intestinal y reducir síntomas.",
        who: "Para personas con síndrome de intestino irritable, SIBO, hinchazón, reflujo, estreñimiento, diarrea, molestias digestivas o dudas sobre posibles alimentos desencadenantes.",
        expect: "Apoyo con el registro de síntomas y alimentos, alimentación adaptada a ti, fibra, líquidos, horarios y cambios dietéticos cuidadosamente planificados."
      },
      {
        key: "womens-health",
        icon: "venus",
        iconColor: "text-purple-600",
        iconBackground: "bg-purple-100",
        title: "Salud de la mujer",
        summary: "Apoyo nutricional para el SOMP, endometriosis, planificación del embarazo, embarazo, diabetes gestacional, perimenopausia y menopausia.",
        what: "Orientación nutricional personalizada para la salud de la mujer, con un enfoque práctico en la alimentación, los hábitos y el bienestar en cada etapa.",
        who: "Para personas que buscan apoyo con SOMP, endometriosis, planificación del embarazo, embarazo, diabetes gestacional, perimenopausia y menopausia.",
        expect: "Un plan individual basado en tus síntomas, prioridades y estilo de vida, con comidas equilibradas y rutinas sostenibles, sin reglas restrictivas."
      },
      {
        key: "diabetes",
        icon: "droplet",
        iconColor: "text-red-500",
        iconBackground: "bg-red-100",
        title: "Prediabetes y diabetes",
        summary: "Orientación práctica para apoyar el control de la glucosa, la resistencia a la insulina, la prediabetes, la diabetes tipo 2 y la planificación de comidas.",
        what: "Apoyo nutricional claro y cotidiano para comprender cómo la alimentación y las rutinas pueden ayudar en el control de la glucosa.",
        who: "Para personas con resistencia a la insulina, prediabetes o diabetes tipo 2 que buscan orientación práctica como complemento a su atención médica.",
        expect: "Exploraremos comidas equilibradas, conocimiento de los hidratos de carbono, horarios regulares, movimiento y cambios realistas sin clasificar los alimentos como buenos o malos."
      },
      {
        key: "blood-tests",
        icon: "clipboard",
        iconColor: "text-rose-600",
        iconBackground: "bg-rose-100",
        title: "Salud cardiovascular",
        summary: "Entiende tus análisis y aprende cómo cambiar parámetros con tu nutrición y hábitos.",
        what: "Una revisión nutricional de análisis recientes para comprender mejor los resultados y convertirlos en acciones realistas. Este servicio no ofrece diagnósticos médicos.",
        who: "Para clientes cuyos análisis indican colesterol, LDL o triglicéridos altos, HDL bajo o a los que se les ha diagnosticado hipertensión.",
        expect: "Hablaremos de tus parámetros sanguíneos, cómo interpretarlos y cómo la alimentación influye en ellos, mientras revisamos tus hábitos y establecemos cambios prácticos que mejoren tu salud cardiovascular."
      }
    ]
  }
};
